import {KitchenType} from "../../property_configurator/types/KitchenType";

export const getKitchenTypeName = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSED:
            return "kuchnia";
        case KitchenType.KITCHENETTE:
            return "aneks kuchenny";
        default:
            return "";
    }
};
import {KitchenType} from "../../property_configurator/types/KitchenType";

export const getKitchenTypeName = (type: KitchenType) => {
    switch (type) {
        case KitchenType.CLOSED:
            return "kuchnia";
        case KitchenType.KITCHENETTE:
            return "aneks kuchenny";
        default:
            return "";
    }
};
